<template>
  <div class="input btn" @mouseleave="blur">
    <input
      v-model="model"
      ref="input"
      type="number"
      placeholder="..."
      :min="min"
      :max="max"
      :step="1"
      @keydown.e.prevent
      @keydown.-.prevent
      @keydown.+.prevent
      @change="setPageFromInput"
    >
    <span @click="input.focus()">nr</span>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const emit = defineEmits(['change']);
const props = defineProps({
  min: Number,
  max: Number,
  current: {
    type: Number,
    default: 1,
  },
});

const input = ref();
const model = ref(null);

const blur = () => {
  if (!model.value) {
    input.value.blur();
  }
}

const setPageFromInput = () => {
  if (model.value !== props.current) {
    if (model.value > props.max) {
      model.value = props.max;
    }

    if (model.value < props.min) {
      model.value = props.min;
    }

    emit('change', model.value);
  } else {
    model.value = null;
  }
};
</script>
